import { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Sidebar } from '../Sidebar';
import { Header } from '../components/Header';
import { CertificateModal } from '../components/CertificateModal';
import { useAuthStore } from '../stores/authStore';
import { Certificate } from '../types';

export const EmployeeLayout = () => {
    const location = useLocation();
    const { user } = useAuthStore();
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [isCertificateModalOpen, setIsCertificateModalOpen] = useState(false);
    const [selectedCertificateData, setSelectedCertificateData] = useState<Certificate | null>(null);

    // Convert path to title
    const getPageTitle = () => {
        const path = location.pathname.split('/')[1];
        switch (path) {
            case 'dashboard': return 'Dashboard';
            case 'courses': return 'My Courses';
            case 'certificates': return 'My Certificates';
            default: return 'Dashboard';
        }
    };

    const handleSidebarToggle = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };

    const handleSidebarClose = () => {
        setIsSidebarOpen(false);
    };

    const handleCloseCertificateModal = () => {
        setIsCertificateModalOpen(false);
        setSelectedCertificateData(null);
    };

    if (!user) {
        return null; // or a loading state
    }

    return (
        <div className="flex h-screen bg-background">
            <Sidebar 
                userRole="employee"
                isOpen={isSidebarOpen}
                onClose={handleSidebarClose}
            />
            <main className="flex-1 flex flex-col overflow-hidden lg:ml-64">
                <Header
                    title={getPageTitle()}
                    onToggleSidebar={handleSidebarToggle}
                />
                <div className="flex-1 overflow-y-auto p-6 relative">
                    <Outlet context={{ 
                        openCertificateModal: (certificate: Certificate) => {
                            setSelectedCertificateData(certificate);
                            setIsCertificateModalOpen(true);
                        }
                    }} />
                </div>
            </main>

            <CertificateModal
                isOpen={isCertificateModalOpen}
                onClose={handleCloseCertificateModal}
                certificateData={selectedCertificateData}
                currentUser={{
                    name: user.name,
                    avatarUrl: `https://ui-avatars.com/api/?name=${encodeURIComponent(user.name)}&background=0D8ABC&color=fff`
                }}
            />
        </div>
    );
}; 